module.exports = __webpack_public_path__ + "img/benefits-23.ffd4e987.svg";